"use strict";

exports.__esModule = true;
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _flatten = _interopRequireDefault(require("./_flatten.js"));
var _filter = _interopRequireDefault(require("./filter.js"));
var _contains = _interopRequireDefault(require("./contains.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
var _default = exports.default = (0, _restArguments.default)(function (array, rest) {
  rest = (0, _flatten.default)(rest, true, true);
  return (0, _filter.default)(array, function (value) {
    return !(0, _contains.default)(rest, value);
  });
});